import { defineComponent as _defineComponent } from 'vue'
import { EXPERIMENTS_CREATOR_GIFT_GUIDES, EXPERIMENTS_TRENDING_POST_CAROUSEL } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopPreviousLayout',
  props: {
  hasPosts: {
    type: Boolean,
  },
  displayName: {
    type: String,
    required: true,
  },
  hasProductsSets: {
    type: Boolean,
  },
},
  setup(__props) {

// TODO - this file is temporary, and will be removed after the Tab Navigation project wraps up
// https://rewardstyle.atlassian.net/browse/BROWSE-1639


return { __sfc: true,EXPERIMENTS_CREATOR_GIFT_GUIDES, EXPERIMENTS_TRENDING_POST_CAROUSEL }
}

})